import { Button, Col, Row, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { data as riskSignaturesData } from './RiskTypeData';
import RenderDot from '@/components/WidgetWrapper/widgets/components/RenderDot';
import styles from '../index.less';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import { truncateString } from '@/utils/utils';

const concatCountAndLabel = (riskCount = 0, riskLabel) => {
  return `${riskCount} ${riskLabel}`;
};

const RiskTypes = props => {
  // push data to dva store in  Single Risk
  const { dispatch, singleRisk, universalDrawer } = props;

  const handleName = riskName => {
    dispatch({
      type: 'singleRisk/changeRiskNames',
      payload: {
        riskName,
      },
    });
  };

  // ~ on unmount clear the riskName
  useEffect(() => {
    return () => {
      dispatch({
        type: 'singleRisk/removeRiskNames',
      });
    };
  }, []);

  return (
    <Row>
      {Object.keys(riskSignaturesData).map(category => {
        // * we have NA as the last item in the array, we don't need to show it so we return null
        if (category === 'NA') {
          return null;
        } else {
          return (
            <Col style={{ marginLeft: '25px' }}>
              <a onClick={() => handleName(riskSignaturesData[category].name)}>
                <RenderDot color={riskSignaturesData[category].style.color} />
                <p
                  className={
                    singleRisk.riskName.includes(riskSignaturesData[category].name)
                      ? styles.riskTitle
                      : styles.riskTitleFd
                  }
                >
                  <Tooltip
                    title={concatCountAndLabel(
                      singleRisk?.riskTypes[riskSignaturesData[category].name],
                      riskSignaturesData[category].name
                    )}
                  >
                    {truncateString(
                      concatCountAndLabel(
                        singleRisk?.riskTypes[riskSignaturesData[category].name],
                        riskSignaturesData[category].name
                      ),
                      15
                    )}
                  </Tooltip>
                </p>
              </a>
            </Col>
          );
        }
      })}
    </Row>
  );
};

export default connect(({ singleRisk }) => ({
  singleRisk,
}))(RiskTypes);
